import React, { useContext } from 'react';

import { Product } from 'types/Product';
import TypeStoreContext from 'context/TypeStoreContext';
import Default from './interfaces/Default';
import Fashion from './interfaces/Fashion';
// import Grocery from './interfaces/Grocery';

interface CardProductProps {
	product: Product;
	isHeartInFashion?: boolean;
}

export default function CardProduct({
	product,
	isHeartInFashion = true
}: CardProductProps) {
	const { typeStore } = useContext(TypeStoreContext);

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <Default product={product} />;

			case 'grocery':
				return <Default product={product} />;

			case 'fashion':
				return (
					<Fashion product={product} isHeartInFashion={isHeartInFashion} />
				);

			default:
				return <Default product={product} />;
		}
	}

	return returnInterfaceByTypeStore();
}
